<div
    class="st-topic-item-condensed-border-left"
    st-left-border
    [data]="data()"></div>
<ng-container *ngIf="data()">
    <div
        class="st-topic-item-condensed-container"
        [class.st-topic-item-condensed-container__mouse-entered]="mouseEntered"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()">
        <div
            *ngIf="extraOwnerCount() > 0"
            class="st-topic-item-condensed-container-badge"
            matBadgeSize="small"
            matBadgePosition="below"
            [matBadge]="extraOwnerCount()"></div>
        <st-avatar
            #triggerOverlay="cdkOverlayOrigin"
            big
            cdkOverlayOrigin
            [userId]="data()?.PSTTopicOwner?.[0]"
            (mouseenter)="showStaffTooltip(data()?.PSTTopicOwner)"
            (mouseleave)="onStoryOwnerMouseOut($event)" />
        <div class="st-topic-item-condensed-container-story">
            <div class="st-topic-item-condensed-container-story-header">
                <div class="st-topic-item-condensed-container-story-header--title">{{ data()?.Title }}</div>
                <div class="st-topic-item-condensed-container-story-header--borders">
                    <div
                        *ngFor="let item of data()?.PSTTopicType"
                        class="st-topic-item-condensed-container-story-header--borders__item"
                        st-topic-card-type-color
                        [matTooltip]="item"
                        [itemType]="item"
                        [data]="data()"></div>
                </div>
            </div>
            <div
                class="st-topic-item-condensed-container-story--desc"
                [class.st-topic-item-condensed-valid]="globalTablesService.FieldDefsDict[this.pstFieldNames.Description]?.Required && !data()?.Description"
                [innerHTML]="description() | linky: { stripPrefix: false } | unsafe: 'html'"></div>
        </div>
        <ng-template
            #storyOwnerEl
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="triggerOverlay"
            [cdkConnectedOverlayOpen]="isListOpen"
            (attach)="storyOwnerPanelAttached()">
            <st-staff-id-list-tooltip [users]="tooltipUsers()" />
        </ng-template>
        <ng-template
            let-item
            ngFor
            [ngForOf]="viewStateCustomCondensedItems$ | ngrxPush">
            <div
                *ngIf="shouldShowCustomFields"
                class="st-topic-item-condensed-container-custom-fields"
                [matTooltip]="getItemString(item, itemStringCache, i18n(), globalTablesService, data(), getInnerProp, highlightPipe, searchString(), clientTimeZone()?.id, currentTimeZone()?.id)">
                {{ getItemString(item, itemStringCache, i18n(), globalTablesService, data(), getInnerProp, highlightPipe, searchString(), clientTimeZone()?.id, currentTimeZone()?.id) }}
            </div>
        </ng-template>

        <div class="st-topic-item-condensed-container-desk">
            <span> {{ topicGroupsItem() }}</span>
        </div>

        <div class="st-topic-item-condensed-container-status">
            <span>{{ data()?.PSTTopicStatus }}</span>
        </div>

        <div class="st-topic-item-condensed-container-assignments">
            @if (data()?.children.length > 0) {
                <st-assignment-icon-list
                    st-click-stop-propagation
                    [value]="data()?.children"
                    [topicEditable]="topicEditable()"
                    [parentRecord]="data()"
                    [maxItemsToShow]="3"
                    [showAddButton]="false"
                    (createAssignmentEvent)="createAssignment($event)"
                    (itemClicked)="openAssignment($event)" />
            }
            <!-- Commented the code insted of deleting it as it might be needed in future -->
            <!-- @if (data()?.children.length === 0) {
                <div class="st-topic-item-condensed-container-assignments--not-assigned">
                    <span>{{ notAssigned }}</span>
                </div>
            } -->
        </div>
        <div class="st-topic-item-condensed-container-stories">
            @if (data()?.stories?.length > 0) {
                <st-story-icon-list
                    st-click-stop-propagation
                    [value]="data()?.stories"
                    [templates]="storyTemplates()"
                    [topicEditable]="topicEditable()"
                    [parentRecord]="data()"
                    [cardDisabled]="false"
                    [maxItemsToShow]="3"
                    [showAddButton]="false"
                    (createStoryEvent)="createStory($event)"
                    (itemClicked)="openStory($event)" />
            }
            <!-- Commented the code insted of deleting it as it might be needed in future -->
            <!-- @if (data()?.stories.length === 0) {
                <div class="st-topic-item-condensed-container-stories--not-assigned">
                    <span>{{ notAssigned }}</span>
                </div>
            } -->
        </div>
        @if (globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.TopicProp) {
            <button
                mat-button
                st-click-stop-propagation
                class="st-topic-item-condensed-container-approve"
                [disabled]="isReadOnly()"
                [matTooltip]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.DefaultCaption"
                [class.st-topic-item-condensed-container-approve--active]="data()?.PSTApproved"
                (click)="updateTopic(!data().PSTApproved, pstFieldNames.PSTApproved)">
                <mat-icon fontSet="material-symbols-outlined">done</mat-icon>
            </button>
        }
        <!--
        <st-external-actions-overlay
            *ngIf="!isPublication"
            class="st-topic-item-condensed-container__more"
            st-click-stop-propagation
            [data]="data()"
            [editable]="topicEditable()"
            [onObjectOpen]="topicItemClicked" /> -->

        <button
            *ngIf="isPublication()"
            mat-icon-button
            class="st-topic-item-condensed-container__delete"
            [disabled]="isReadOnly()"
            (click)="deletePublication($event)">
            <mat-icon>delete_outline</mat-icon>
        </button>

        <!-- <ng-template #assignmentsOverlay>
            <ng-template
                #assignmentsOverlayEl
                cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="triggerAssignmentOverlay"
                [cdkConnectedOverlayOpen]="isAssignmentsPanelOpen"
                (attach)="assignmentsPanelAttached()">
                <st-assignments-overlay
                    [data]="data()"
                    [editable]="topicEditable()"
                    [isPanelOpen]="isAssignmentsPanelOpen"
                    [onObjectOpen]="assignmentItemClicked" />
            </ng-template>
        </ng-template> -->
    </div>
</ng-container>
